<template>
    <div class="categ_info" v-if="obj_to_null(this.item)">
        <info_field f_uniq="ct" f_type="displayName"
                    @update_categ="change_atr"
                    :f_title="__t('NAME')"
                    :is_disabled="is_disabled"
                    :f_val="cur_item.displayName" />


        <info_field f_uniq="short_code" f_type="short_code" @update_categ="change_atr" :f_title="__t('SHORT_CODE')" :is_disabled="is_disabled" :f_val="cur_item.short_code" />


        <info_field f_uniq="cid" :f_title="__t('UNIQ_GO_CODE')"  :f_val="cur_item.id.toString()"></info_field>
        <info_field  f_uniq="cuid" :f_title="__t('UNIQ_PROV_CODE')" :f_val="cur_item.uniq_id"></info_field>



        <div class="form-group mt-2">
            <div  class="panel-tag">
                {{__t('EMPLOY_NAME_DATA')}}
            </div>

            <info_field f_uniq="firstName" f_type="firstName" @update_categ="change_atr" :f_title="__t('FIRST_NAME')" :is_disabled="is_disabled" :f_val="cur_item.firstName" />
            <info_field f_uniq="middleName" f_type="middleName" @update_categ="change_atr" :f_title="__t('MIDDLE_NAME')" :is_disabled="is_disabled" :f_val="cur_item.middleName" />
            <info_field f_uniq="lastName" f_type="lastName" @update_categ="change_atr" :f_title="__t('LAST_NAME')" :is_disabled="is_disabled" :f_val="cur_item.lastName" />
            <info_field f_uniq="phone" f_type="phone" @update_categ="change_atr" :f_title="__t('PHONE')" :is_disabled="is_disabled" :f_val="cur_item.phone" />

        </div>

        <div class="form-group mt-2">
            <label class="form-label" for="organization">
                {{__t("ORGANIZATION")}}
            </label>

            <div class="" v-if="organizations.length > 0">
                <v-select v-model="cur_item.org_id"
                          class="imc_reasons"
                          label="title"
                          :reduce="item => item.id"
                          :options="this.organizations"
                          :filterable="false"
                >
                    <template slot="no-options">
                        {{__t("CHOICE_ORG")}}
                    </template>

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            <div>
                                {{ option.title }}
                                <span class="small badge border border-info  text-info mr-1"> {{option.provider}}</span>
                            </div>
                            <div>
                                <small>
                                    {{option.uniq_id}}
                                </small>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

    </div>
</template>

<script>
import Info_field from "../../../../sys/info_field";
import vSelect from 'vue-select'
export default {
    name: "employ_info",
    components: {Info_field,vSelect},
    props : {
        item : {
            type : Object
        }
    },
    data() {
        return {
            cur_item : this.item,
            is_load: false,
            organizations : [],
        }
    },

    created() {
        this.load_organizations();


        EventBus.$on('save_employ',this.save_employ)
    },

    methods :  {
        async save_employ() {
            console.log('save_employ',this.cur_item);
            this.is_load = true;
            let self = this;

            //We only save Publish and Surname
            await api.put('/internal/v1/catalog/employees/' + parseInt(this.item.id),this.cur_item).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.Onclose();
                }

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
            });

        },

        change_atr(atr_name,atr_val) {
            if(this.item.hasOwnProperty(atr_name)) {
                this.item[atr_name] = atr_val;
            }
        },

        async load_organizations() {
            this.organizations = [];
            await api.post('/internal/v1/catalog/organizations',{}).then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.organizations = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    position : "b-toaster-top-left",
                    type: "danger",
                    title: response.data.status})
            });
        },

        Onclose() {
            EventBus.$emit("close_employ");
            EventBus.$emit("reload_employees");
        },
    },
    computed : {
        is_disabled () {
            return false;
        },


    },
}
</script>

<style scoped>

</style>
